<template>
  <div class="fraude">
    <headNav :activeNav="'fraude'"></headNav>
    <div class="banner">
      <div style="color: #ffc300">EVITA QUE TE ENGAÑEN</div>
      <div style="color: #ffffff">COMO DETECTAR UN FRAUDE</div>
    </div>
    <div class="center">
      <div class="top">
        <div>
          <img src="../assets/image/fraude_two.png" alt="" />
          <div class="common one">PLANTILLA DE ASESOR</div>
        </div>
        <div style="margin-left: -115px">
          <div class="common two">CÓDIGO DE PAGO</div>
          <img src="../assets/image/fraude_three.png" alt="" class="img_two" />
        </div>
        <div>
          <img src="../assets/image/fraude_four.png" alt="" />
          <div class="common three">
            SMS SOLICITANDO<br />CONTRASEÑA Y USUARIO
          </div>
        </div>
      </div>
      <div class="bottom">
        <div>
          <img src="../assets/image/fraude_five.png" alt="" />
          <div>
            Nuestros envios de Whatsapp siempre un asesor se presentara con su
            nombre. Evita plantillas sin identiflcación.
          </div>
        </div>
        <div>
          <img src="../assets/image/fraude_six.png" alt="" />
          <div>
            Todas nuestras referencias o códigos de pago que te brindemos deberá
            ir una captura ya sea por PagoEfectivo, Payválida, Safetypay y
            Paycash.
          </div>
        </div>
        <div>
          <img src="../assets/image/fraude_seven.png" alt="" />
          <div>
            Ningún mensaje de SMS te solicitara tu código de SMS o tu usuario y
            contraseña. Ya que será un posible fraude.
          </div>
        </div>
         <div>
          <img src="../assets/image/fraude_eightNew.png" alt="" />
          <div>
            Recuerda toda comunicación es con número peruano:+51*********. Hacer
            caso omiso a cualquier número extranjero.
          </div>
        </div>
      </div>
    </div>
    <div class="ekecash">
      <div class="title">
        <!-- <h1 style="margin-bottom: 15px">QUÉ TIPO DE CÓDIGO DE PAGO EXISTEN</h1> -->
        <!-- <h1 style="margin-bottom: 18px">EKECASH</h1> -->
        <h1 style="margin-bottom: 15px">
          QUÉ TIPO DE CÓDIGO DE PAGO EXISTE EN EKECASH
        </h1>
        <div class="ekecash_line"></div>
        <p>
          Nota: ¡No confíe en otros canales de pago que no sean de nosotros!
        </p>
      </div>
      <img src="../assets/image/fraude_eight.png" alt="" />
    </div>
    <div class="footer">
      <div class="top_green">
        Estos son los códigos que los asesores te mandaran para apoyarte a
        realizar la cancelación de tu credito. <br />
        Los únicos medios de código son PAGOEFECTIVO,Payválida,
        SAFETYPAY,PAYCASH.
      </div>
      <div class="bottom_green">
        <h1>Contáctanos</h1>
        <div class="bottom_flex">
          <div>
            <p>Email: <span>servicio@ekecash.pe</span></p>
            <p>Whatsapp: <span>+51 902354205</span></p>
            <p>Número de teléfono: +51 17017698</p>
          </div>
          <!-- <div>
            <p style="margin-bottom: 20px">Departamento de promociones</p>
            <p>Número de teléfono: 5527230433</p>
            <p>Whatsapp link: <span>wa.link/h8p1s0</span></p>
            <p>Correo: <span>ekecashpromociones@gmail.com</span></p>
          </div>
          <div>
            <p style="margin-bottom: 20px">
              Departamento de quejas y sugerencias
            </p>
            <p>Número de teléfono: 51902514568</p>
            <p>Whatsapp link: <span>wa.link/x5riwm</span></p>
            <p>Correo: <span>EkecashATC@gmail.com</span></p>
          </div> -->
        </div>
        <!-- <div class="bottom_title">
          PERUCRED DIGITAL FINANCE SOCIEDAD ANONIMA CERRADA . Todos los derechos
          reservados
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import headNav from "@/components/headNav.vue";

export default {
  components: { headNav },

  data() {
    return {};
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.fraude {
  .banner {
    width: 100%;
    height: 330px;
    background: url("../assets/image/fraude_one.png") 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 50px;
    font-family: Arial-Black, Arial;
    font-weight: 900;
    color: #ffc300;
  }
  .center {
    background: #f2f2f2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 63px 0 78px;
    box-sizing: border-box;

    .top {
      padding-bottom: 108px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;
      > div {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        img {
          width: 254px;
          margin-right: -125px;
          z-index: 999;
        }
        .img_two {
          margin-left: -125px;
        }
        .common {
          width: 788px;
          height: 156px;
          border-radius: 78px;
          font-size: 50px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #333333;
          line-height: 156px;
          text-align: center;
          padding-left: 75px;
          box-sizing: border-box;
        }
        .one {
          background: rgba(255, 195, 0, 0.3);
        }
        .two {
          background: rgba(99, 221, 0, 0.3);
          padding-right: 75px;
        }
        .three {
          background: rgba(0, 242, 255, 0.3);
          display: flex;
          align-items: center;
          line-height: 55px;
          justify-content: center;
        }
      }
    }
    .bottom {
      display: flex;
      flex-direction: column;
      width: 1200px;
      margin: 0 auto;
      > div {
        display: flex;
        margin-bottom: 28px;
        img {
          width: 60px;
          height: 73px;
        }
        div {
          font-size: 32px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 500;
          color: #333333;
          padding-top: 39px;
          margin-left: -47px;
        }
      }
    }
  }
  .ekecash {
    background: #fff;
    padding: 72px 0 166px;
    box-sizing: border-box;
    width: 1200px;
    margin: 0 auto;
    .title {
      display: flex;
      flex-direction: column;
      align-items: center;
      .ekecash_line {
        width: 187px;
        height: 1px;
        border-bottom: 7px solid #029f0a;
      }
      p {
        font-size: 26px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: #333333;
        margin-top: 39px;
      }
    }
    img {
      // margin-top: 140px;
      margin-top: 71px;
    }
  }
  .footer {
    .top_green {
      width: 100%;
      height: 185px;
      background: rgba(2, 159, 10, 0.3);
      font-size: 26px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 600;
      color: #007006;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
    .bottom_green {
      background: #142e16;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      padding: 28px 0 70px;
      box-sizing: border-box;
      h1 {
        text-align: center;
        margin-bottom: 55px;
        font-size: 32px;
      }

      .bottom_flex {
        // display: flex;
        // justify-content: space-between;
        font-size: 24px;
        // width: 1200px;
        margin: 0 auto;
        width: 500px;
        p {
          margin-bottom: 10px;
          span {
            color: #ffc029;
            text-decoration: underline;
          }
          &:last-child {
            margin: 0;
          }
        }
      }
      .bottom_title {
        color: #fff;
        text-align: center;
        padding: 30px 0;
        box-sizing: border-box;
      }
    }
  }
}
</style>